<template>
  <v-checkbox
    :name="name"
    :label="schema.label"
    :required="!schema.optional"
    :rules="validationRules"
    :error-messages="errorMessages"
    v-model="checked"
    :solo="schema.solo"
  />
</template>
<script>
export default {
  props: {
    /** Current Value */
    value: { type: Boolean, default: false },
    /** Validation Errors */
    errorMessages: { type: String },
    /** Field Name */
    name: { type: String, required: true },
    /** Field Schema */
    schema: { type: Object, default: () => ({}) },
    /** Disabled state */
    disabled: { type: Boolean, default: false }
  },
  components: {
  },
  data () {
    return {
      checked: ''
    }
  },
  methods: {
    /** Validation Rules */
    validationRules () {
      const rules = []
      // Required validation
      if (!this.schema.optional) {
        rules.push((v) => v || 'Campo requerido.')
      }
      return rules
    },
    /** Additional field options */
    fieldOptions () {
      return this.schema.fieldOptions || {}
    }
    /* get checked () {
      return !!this.value
    },
    set checked (value) {
      this.$emit('input', value)
    } */
  }
}
</script>
